[
  {
    "posting_id": "job-001",
    "job_title": "Adventist Health Nurse Scholar Program",
    "employer_name": "LLUMC",
    "employment_type": "Internship",
    "location": "Loma Linda, CA",
    "is_internship": true,
    "is_active": false,
    "employment_location_type": "In-person",
    "posting_date": "3 days ago",
    "related_to_career_goal": false,
    "is_bookmarked": false,
    "skills": ["Patient Care", "Clinical Assessment", "Healthcare Documentation", "Medical Terminology"],
    "match_score": 0.95,
    "score_category": "Very High Category",
    "match_summary": {
      "skills_category": "Very High",
      "work_history_category": "Low",
      "education_category": "Medium"
    },
    "skill_gaps": ["Advanced Cardiac Life Support", "Pediatric Nursing"],
    "job_url": "https://example.com/jobs/adventist-nurse-scholar",
    "summary": [
      "Participate in a comprehensive nurse training program designed to develop clinical skills and professional competencies.",
      "Work alongside experienced nurses in various healthcare settings including medical-surgical, ICU, and emergency departments.",
      "Receive mentorship and hands-on training in patient assessment, care planning, and evidence-based practice.",
      "Gain exposure to interdisciplinary healthcare teams and collaborative care models.",
      "Eligible for full-time employment upon successful completion of the program and licensure."
    ],
    "education": [
      {
        "degree_type": "Bachelor of Science in Nursing",
        "level": "Undergraduate",
        "required": true,
        "subject": "Nursing"
      }
    ],
    "certifications": ["BLS Certification", "Active Nursing Student Status"]
  },
  {
    "posting_id": "job-002",
    "job_title": "Kaiser Permanente Student Nurse (Intern)",
    "employer_name": "Kaiser Permanente",
    "employment_type": "Full time",
    "location": "Woodland Hills, CA",
    "is_internship": true,
    "is_active": false,
    "employment_location_type": "In-person",
    "posting_date": "7 hours ago",
    "related_to_career_goal": false,
    "is_bookmarked": false,
    "skills": ["Patient Care", "Vital Signs Monitoring", "Electronic Health Records", "Team Collaboration"],
    "match_score": 0.92,
    "score_category": "Very High Category",
    "match_summary": {
      "skills_category": "Very High",
      "work_history_category": "Medium",
      "education_category": "High"
    },
    "skill_gaps": ["IV Therapy", "Wound Care Management"],
    "job_url": "https://example.com/jobs/kaiser-student-nurse",
    "summary": [
      "Join Kaiser Permanente's award-winning Student Nurse Internship program in a state-of-the-art medical facility.",
      "Provide direct patient care under the supervision of licensed nursing staff in acute care settings.",
      "Learn to utilize Kaiser's integrated electronic health record system and clinical documentation standards.",
      "Participate in quality improvement initiatives and evidence-based practice projects.",
      "Develop critical thinking and clinical decision-making skills through structured learning experiences."
    ],
    "education": [
      {
        "degree_type": "Bachelor of Science in Nursing",
        "level": "Undergraduate",
        "required": true,
        "subject": "Nursing"
      }
    ],
    "certifications": ["BLS Certification", "CPR Certification"]
  },
  {
    "posting_id": "job-003",
    "job_title": "ACES Behavior Analyst Intern",
    "employer_name": "NY (various locations)",
    "employment_type": "Internship",
    "location": "Los Angeles, CA",
    "is_internship": true,
    "is_active": false,
    "employment_location_type": "In-person",
    "posting_date": "Timestamp",
    "related_to_career_goal": false,
    "is_bookmarked": false,
    "skills": ["Applied Behavior Analysis", "Data Collection", "Behavioral Assessment", "Client Communication"],
    "match_score": 0.88,
    "score_category": "High Category",
    "match_summary": {
      "skills_category": "Very High",
      "work_history_category": "Low",
      "education_category": "High"
    },
    "skill_gaps": ["BCBA Supervision", "Functional Behavior Assessment", "Crisis Intervention"],
    "job_url": "https://example.com/jobs/aces-behavior-analyst",
    "summary": [
      "Work with individuals with autism spectrum disorder and developmental disabilities to implement behavior intervention plans.",
      "Collect and analyze behavioral data to monitor client progress and inform treatment decisions.",
      "Collaborate with Board Certified Behavior Analysts (BCBAs) to develop and modify individualized treatment programs.",
      "Provide training and support to families and caregivers on behavioral strategies and techniques.",
      "Gain supervised fieldwork hours toward BCBA certification requirements."
    ],
    "education": [
      {
        "degree_type": "Bachelor's Degree",
        "level": "Undergraduate",
        "required": true,
        "subject": "Psychology or Related Field"
      }
    ],
    "certifications": []
  },
  {
    "posting_id": "job-004",
    "job_title": "Summer Pharmacy Intern",
    "employer_name": "Walgreens",
    "employment_type": "Internship",
    "location": "CA (various locations)",
    "is_internship": true,
    "is_active": false,
    "employment_location_type": "In-person",
    "posting_date": "Timestamp",
    "related_to_career_goal": false,
    "is_bookmarked": false,
    "skills": ["Pharmacy Operations", "Medication Dispensing", "Customer Service", "Inventory Management"],
    "match_score": 0.82,
    "score_category": "High Category",
    "match_summary": {
      "skills_category": "Very High",
      "work_history_category": "Low",
      "education_category": "High"
    },
    "skill_gaps": ["Compounding", "Immunization Administration", "Pharmacotherapy"],
    "job_url": "https://example.com/jobs/walgreens-pharmacy-intern",
    "summary": [
      "Assist licensed pharmacists in dispensing medications and providing patient counseling services.",
      "Learn pharmacy workflow processes including prescription verification, insurance billing, and inventory control.",
      "Provide immunizations and health screenings under pharmacist supervision (where state regulations permit).",
      "Engage with customers to answer medication questions and promote health and wellness services.",
      "Gain practical experience in community pharmacy operations and patient-centered care delivery."
    ],
    "education": [
      {
        "degree_type": "Doctor of Pharmacy",
        "level": "Doctoral",
        "required": true,
        "subject": "Pharmacy"
      }
    ],
    "certifications": ["Active Pharmacy Student", "State Pharmacy Intern License"]
  },
  {
    "posting_id": "job-005",
    "job_title": "Summer III Student Nurse Internship",
    "employer_name": "Mayo Clinic",
    "employment_type": "Internship",
    "location": "Rochester, MN",
    "is_internship": true,
    "is_active": false,
    "employment_location_type": "Remote",
    "posting_date": "Yesterday",
    "related_to_career_goal": false,
    "is_bookmarked": false,
    "skills": ["Clinical Nursing", "Patient Assessment", "Critical Care", "Interdisciplinary Collaboration"],
    "match_score": 0.75,
    "score_category": "Medium Category",
    "match_summary": {
      "skills_category": "Very High",
      "work_history_category": "Low",
      "education_category": "High"
    },
    "skill_gaps": ["Telemetry", "Critical Care Protocols", "Emergency Response", "Advanced Life Support", "Specialized Equipment"],
    "job_url": "https://example.com/jobs/mayo-clinic-nurse-intern",
    "summary": [
      "Experience nursing practice in one of the nation's top-ranked hospitals with access to cutting-edge medical technology.",
      "Work in specialized units including medical-surgical, critical care, oncology, or cardiovascular care.",
      "Participate in interdisciplinary rounds and collaborate with physicians, therapists, and other healthcare professionals.",
      "Engage in evidence-based practice initiatives and quality improvement projects.",
      "Receive comprehensive orientation and ongoing education from Mayo Clinic's renowned nursing education team."
    ],
    "education": [
      {
        "degree_type": "Bachelor of Science in Nursing",
        "level": "Undergraduate",
        "required": true,
        "subject": "Nursing"
      }
    ],
    "certifications": ["BLS Certification", "ACLS Certification (Preferred)"]
  },
  {
    "posting_id": "job-006",
    "job_title": "Experiential Learning & Opportunity Internship Program",
    "employer_name": "NCDHHS",
    "employment_type": "Internship",
    "location": "CA (various locations)",
    "is_internship": true,
    "is_active": false,
    "employment_location_type": "Remote",
    "posting_date": "12 days ago",
    "related_to_career_goal": false,
    "is_bookmarked": false,
    "skills": ["Public Health", "Program Development", "Data Analysis", "Community Outreach"],
    "match_score": 0.70,
    "score_category": "Medium Category",
    "match_summary": {
      "skills_category": "Very High",
      "work_history_category": "Low",
      "education_category": "High"
    },
    "skill_gaps": ["Health Policy", "Grant Writing", "Epidemiology", "Statistical Software", "Program Evaluation"],
    "job_url": "https://example.com/jobs/ncdhhs-experiential-learning",
    "summary": [
      "Gain hands-on experience in public health programs and initiatives within a state health department.",
      "Support the development and implementation of health promotion and disease prevention programs.",
      "Conduct data analysis and contribute to program evaluation and quality improvement efforts.",
      "Collaborate with community partners and stakeholders to address health disparities and social determinants of health.",
      "Participate in policy research and contribute to the development of evidence-based public health interventions."
    ],
    "education": [
      {
        "degree_type": "Bachelor's Degree",
        "level": "Undergraduate",
        "required": true,
        "subject": "Public Health or Related Field"
      }
    ],
    "certifications": []
  }
]
